import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, CalendarDays, Dumbbell, ClipboardList, TrendingUp, User, LogOut, Flag } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/calendar", label: "Calendar", icon: CalendarDays },
  { to: "/rounds", label: "Rounds", icon: ClipboardList },
  { to: "/progress", label: "Progress", icon: TrendingUp },
  { to: "/profile", label: "Profile", icon: User },
];

export default function Layout({ children }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = () => { logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex">
      {/* Desktop sidebar */}
      <aside className="hidden md:flex md:flex-col w-60 border-r border-[#262626] bg-[#0d0d0d] fixed h-screen z-20">
        <div className="px-6 py-6 border-b border-[#262626] flex items-center gap-2">
          <Flag className="text-[#CCFF00]" size={22} />
          <span className="font-heading text-xl leading-none">PAR<span className="text-[#CCFF00]">PREP</span></span>
        </div>
        <nav className="flex-1 py-6 flex flex-col gap-1 px-3">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm font-semibold uppercase tracking-wide transition-colors ${
                  isActive ? "bg-[#CCFF00] text-[#0A0A0A]" : "text-[#A3A3A3] hover:text-white hover:bg-[#1F1F1F]"
                }`}>
              <n.icon size={18} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={doLogout} data-testid="logout-button"
          className="m-3 flex items-center gap-3 px-4 py-3 text-sm font-semibold uppercase tracking-wide text-[#A3A3A3] hover:text-[#FF3B30] transition-colors border border-[#262626]">
          <LogOut size={18} /> Logout
        </button>
      </aside>

      {/* Main */}
      <main className="flex-1 md:ml-60 pb-24 md:pb-0 min-h-screen">{children}</main>

      {/* Mobile bottom nav */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-[#0d0d0d] border-t border-[#262626] flex">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} data-testid={`mnav-${n.label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center gap-1 py-3 text-[10px] font-bold uppercase tracking-wide ${
                isActive ? "text-[#CCFF00]" : "text-[#A3A3A3]"
              }`}>
            <n.icon size={20} />
            {n.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
